import React from "react";
import { Link } from "react-router-dom";
import { homePageV2Programs } from "../content/homePageV2Content";

export function ProgramsSectionV2() {
  const { items, link } = homePageV2Programs;

  return (
    <section className="mh2v2-programs mh2v2-section-charcoal">
      <div className="mh2v2-container">
        <h3 className="mh2v2-section-title mh2v2-section-title--center mh2v2-section-title--light">
          SIGNATURE MAMAHOOD PROGRAMS
        </h3>

        <div className="mh2v2-program-list">
          {/* TODO: programs catalog CMS */}
          {items.map((program) => (
            <article
              className={`mh2v2-program-card ${program.theme}`}
              key={program.title}
              style={{
                "--program-image-position": program.imagePosition || "50% 40%",
                "--program-image-scale": program.imageScale || 1,
              }}
            >
              <div className="mh2v2-program-card__media">
                <img src={program.image} alt={program.title} />
              </div>
              <div className="mh2v2-program-card__overlay">
                <h4>{program.title}</h4>
                <Link to={program.to} className="mh2v2-pill mh2v2-pill--gold">
                  More Info →
                </Link>
                <p>{program.subtitle}</p>
              </div>
            </article>
          ))}
        </div>

        <Link className="mh2v2-link-row mh2v2-link-row--light" to={link.to}>
          {link.label} →
        </Link>
      </div>
    </section>
  );
}

export default ProgramsSectionV2;
